import { CDNDOMAIN, OSSDOMAIN, project, curProject, curScheme, ENV, UA } from 'CONFIG/config';
import { envData, envConf } from 'ENV';
import validate from './validate';
import axios from 'axios';
import dayjs from 'dayjs';
import { decode } from './Axios';

/**
 * 前置补零
 *
 * @param {*} val 数字
 * @param {number} [len=2] 期望长度
 * @returns
 */
function addZero(val, len = 2) {
  len = Math.max(len, String(val).length);
  return `${new Array(len).join(0)}${val}`.slice(-len);
}

/**
 *
 *
 * @param {*} icon 接口返回路径
 * @param {number} [width=50] 返回图片宽度,默认50,等比缩放
 * @returns
 */
function avatarAnalysis(icon, width = 150) {
  // 判断新旧解析的标准
  if (!/upload\//g.test(icon)) {
    return oldWay(icon);
  } else {
    return `${envConf.pic}/${icon}?x-oss-process=image/resize,m_lfit,h_${width},w_${width}`;
  }
}

// 判断浏览器内核、手机系统等，使用 browser.version.ios
var browser = (function () {
  var u = navigator.userAgent;
  var ua = navigator.userAgent.toLocaleLowerCase();

  return {
    isAlipay: /alipay|aliapp|alipayclient/i.test(u),
    trident: u.indexOf('Trident') > -1, // IE内核
    presto: u.indexOf('Presto') > -1, // opera内核
    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // IOS终端
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // 安卓终端
    iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iphone或QQHD浏览器
    iPad: u.indexOf('iPad') > -1, // 是否为iPad
    webApp: u.indexOf('Safari') == -1, // 是否web应用程序，没有头部与底部
    QQbrw: u.indexOf('MQQBrowser') > -1 || u.indexOf('QQBrowser') > -1, // QQ浏览器
    weiXin: u.indexOf('MicroMessenger') > -1, // 微信
    QQ: /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d\.]+)/i.test(ua) || /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/i.test(ua), // QQ
    QZ: u.indexOf(/Qzone/i) > -1, // QQ
    weiBo: u.indexOf(/WeiBo/i) > -1, // 微博
    ucLowEnd: u.indexOf('UCWEB7.') > -1, //
    ucSpecial: u.indexOf('rv:1.2.3.4') > -1,
    webview: !(u.match(/Chrome\/([\d.]+)/) || u.match(/CriOS\/([\d.]+)/)) && u.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
    ucweb: (function () {
      try {
        return (
          parseFloat(
            u
              .match(/ucweb\d+\.\d+/gi)
              .toString()
              .match(/\d+\.\d+/)
              .toString()
          ) >= 8.2
        );
      } catch (e) {
        if (u.indexOf('UC') > -1) {
          return true;
        }
        return false;
      }
    })(),
    Symbian: u.indexOf('Symbian') > -1,
    ucSB: u.indexOf('Firofox/1.') > -1,
  };
})();

/**
 *  强制清理缓存
 *  @param { String } url, 带有版本的json/html文件路径
 *  @param { Boolean } isForce, 是否强制刷新
 *  @param { String } act, 页面标识
 *  通用写法：cleanCache(location.pathname, null, 'ver@' + location.pathname);
 */
const cleanCache = (url, isForce, act, hash = '') => {
  let pathname = location.pathname;

  // 双斜杆处理
  if (/^\/{2,}/.test(pathname) && pathname === url) {
    url = url.replace(/^\/{2,}/, '/');
  }

  act = act || 'webVer';
  url = url || './static/app.json';
  url = getAbsoluteURL(url);
  url += `?t=${new Date().getTime()}`;

  if (isForce) {
    location.replace(getClearCacheUrl(location.href));
    return;
  }

  axios
    .get(url)
    .then((res) => {
      let { data } = res;
      let version = '';

      // 判断是否通过index.html来判断
      if (/\/static\/app\.json/.test(url)) {
        version = data.version;
      }
      // 通过自身版本号判断
      else {
        // 获取页面上的版本号
        version = data.toString().match(/window\.webVer\s*=\s*('|")(.*?)\1/);
        if (version) {
          version = version[2];
        }
      }

      // 如果不为空
      if (!version) {
        return;
      }

      // 如果版本号不一样，则刷新
      if (window.webVer && window.webVer !== version) {
        localStorage.setItem(act, version);
        location.replace(getClearCacheUrl(location.href, '_t', version) + hash);
      } else {
        localStorage.setItem(act, version);
      }
      console.log('v' + version);
    })
    .catch((err) => {});
};

/**
 *
 *
 * @param {开始日期} startTime
 * @param {截止日期} endTime
 * @returns 两个日期内间隔的日期数组,例如[2018-01-01 00:00:00,]
 */
function createDateAry(startTime, endTime) {
  const ary = [];
  const start = getZeroDate(startTime * 1000);
  const end = endTime * 1000 <= +new Date() ? getZeroDate(endTime * 1000) : getZeroDate();
  const diff = dayjs(end).diff(dayjs(start), 'day') + 1;

  for (let i = 0; i < diff; i++) {
    let dateStr = dayjs(start).add(i, 'day').format('M月DD日');
    let timestamp = Math.round(dayjs(dayjs(start).add(i, 'day').format('YYYY-MM-DD') + ' 00:00:00') / 1000);
    let item = {
      dateStr,
      timestamp,
    };

    ary.push(item);
  }
  return ary;
}

function createFormSubmit(url, params, target) {
  var tempform = document.createElement('form');
  tempform.action = url;
  tempform.method = 'post';
  tempform.style.display = 'none';
  if (target) {
    tempform.target = target;
  }

  for (var x in params) {
    var _opt = document.createElement('input');
    _opt.name = x;
    _opt.value = params[x];
    tempform.appendChild(_opt);
  }

  var opt = document.createElement('input');
  opt.type = 'submit';
  tempform.appendChild(opt);
  document.body.appendChild(tempform);
  tempform.submit();
  document.body.removeChild(tempform);
}

//动态创建a标签并跳转
function createHref(href) {
  const aDom = document.createElement('a'); // 创建a标签
  aDom.setAttribute('href', href); // href链接
  aDom.setAttribute('id', 'startHref');
  aDom.setAttribute('target', '_blank');

  // 防止反复添加
  if (document.getElementById('startHref')) {
    document.body.removeChild(document.getElementById('startHref'));
  }
  document.body.appendChild(aDom);

  aDom.click(); // 自执行点击事件
}

/**
 *
 * @param {最小值} m
 * @param {最大值} n
 */
function createRandom(m, n) {
  return Math.random() * (+n + 1 - m) + m;
}

/**
 * 防抖函数就是在一定时间内，再次触发函数就会清除定时器重新设置延迟时间执行,适用于非高频率操作。
 * @param  {Function} fn                [执行函数]
 * @param  {Number}   [interval=1000]       [间隔时间]
 * @param  {Boolean}  [immediate=false] [是否立即执行]
 * @return {[type]}                     [function]
 */
function debounce(fn, interval = 1000, immediate = false) {
  // 定时器
  let timer;
  return function () {
    const self = this;

    // 保存参数

    const args = arguments;
    if (timer) clearTimeout(timer);
    // 是否立即执行
    if (immediate) {
      fn.apply(self, args);
      immediate = false;
    }
    timer = setTimeout(() => {
      fn.apply(self, args);
    }, interval);
  };
}

/*
 * 转义 < > " '  空格不转义
 * @param str
 * @returns {*}
 */
function escapeHtml(str) {
  if (!str) return '';
  str = str.replace(/&/g, '&amp;');
  str = str.replace(/</g, '&lt;');
  str = str.replace(/>/g, '&gt;');
  str = str.replace(/"/g, '&quto;');
  str = str.replace(/'/g, '&#39;'); // html实体
  return str;
}

/**
 * 禁止IOS双击自动滚动
 */

function fixedIOSScroll() {
  // 屏蔽IOS双击
  var agent = navigator.userAgent.toLowerCase();
  var iLastTouch = null;
  if (agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
    document.body.addEventListener(
      'touchend',
      function (event) {
        var a = new Date().getTime();
        iLastTouch = iLastTouch || a + 1;
        var c = a - iLastTouch;
        if (c < 500 && c > 0) {
          event.preventDefault();
          return false;
        }
        iLastTouch = a;
      },
      false
    );
  }
}

// 获取屏幕高度  整体弹性布局
function flexHeight(ref, offset) {
  const clientHeight = document.documentElement.clientHeight;
  offset = typeof offset === 'undefined' ? 0 : ~~offset;
  ref.style.height = clientHeight - offset + 'px';
}

/**
 * 格式化时间为字符串,
 * @param { Date | Number | String (Date String)} date 日期Date对象或可作为Date参数的字符串,数字
 * @param {string} [formatStr='YYYY-MM-DD hh:mm:ss'] 输出格式
 */
function formatDate(date, formatStr = 'YYYY-MM-DD hh:mm:ss') {
  if (!date) {
    date = new Date();
  } else {
    // 后台时间戳, 需 x 1000
    if (typeof date === 'number' && date < 10000000000) {
      date *= 1000;
    }
    date = new Date(date);
  }
  let year = date.getFullYear();
  let mon = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();
  return formatStr.replace(/[Y|M|D|h|m|s]+/g, function (s) {
    // 是否需要补0 'Y-M-D h:m:s' 这样的格式不补0
    let padStart = s.length > 1;
    switch (s[0]) {
      case 'Y':
        return formatNum(year);
      case 'M':
        return formatNum(mon, padStart);
      case 'D':
        return formatNum(day, padStart);
      case 'h':
        return formatNum(hour, padStart);
      case 'm':
        return formatNum(min, padStart);
      case 's':
        return formatNum(sec, padStart);
      default:
        return s;
    }
  });
}

/**
 * 格式化时间 传入date类型
 * @param date
 * @returns {{d: (*|number), h: any | number, y: number, m: string, minute: any | number, second: any | number}}
 */
function formatDateObj(date) {
  date = new Date(date);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  let d = date.getDate();
  d = d < 10 ? '0' + d : d;
  let h = date.getHours();
  h = h < 10 ? '0' + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return {
    y,
    m,
    d,
    h,
    minute,
    second,
  };
}

// 时间戳转天时分秒
function formatDuring(mss) {
  if (mss < 0) {
    return {
      total: '00',
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    };
  }

  var days = addZero(parseInt(mss / (1000 * 60 * 60 * 24)));
  var hours = addZero(parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
  var minutes = addZero(parseInt((mss % (1000 * 60 * 60)) / (1000 * 60)));
  var seconds = addZero(Math.floor((mss % (1000 * 60)) / 1000));
  if (seconds === 60) {
    minutes++;
    seconds = 0;
  }
  if (minutes === 60) {
    hours++;
    minutes = 0;
  }
  if (hours === 24) {
    days++;
    hours = 0;
  }
  return {
    total: mss,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
}

/**
 *
 * 格式化数字为字符串
 * @param {*} num
 * @param {*} padStart 不足两位时,是否在首为填'0'
 */
function formatNum(num, padStart = true) {
  if (padStart) {
    return num > 9 ? '' + num : '0' + num;
  } else {
    return '' + num;
  }
}

/**
 * 将相对地址转绝地地址
 * @params { String } 相对地址
 * @returns { String } 绝对地址
 */
const getAbsoluteURL = (url) => {
  let link = document.createElement('a');
  let absoluteURL = '';
  let pathname = location.pathname;

  // 双斜杆处理
  if (/^\/{2,}/.test(pathname) && pathname === url) {
    url = url.replace(/^\/{2,}/, '/');
  }

  link.href = url;
  absoluteURL = link.href;
  link = null;

  return absoluteURL;
};

/**
 * 获取清除缓存的链接
 */
const getClearCacheUrl = (url, key, version) => {
  var key = (key || '_t') + '='; // 默认是 "_t"
  var reg = new RegExp(key + '(\\d+\\.)*\\d+'); // 正则：t=1472286066028/1.x.x
  var timestamp = version || +new Date();

  if (url.indexOf(key) > -1) {
    // 有时间戳，直接更新
    return url.replace(reg, key + timestamp);
  } else {
    // 没有时间戳，加上时间戳
    var newUrlArr = [];
    var urlArr = url.split('#');
    var baseUrl = urlArr[0];
    var hash = urlArr[1] ? '#' + urlArr[1] : '';

    if (baseUrl.indexOf('?') > -1) {
      var tmpUrlArr = baseUrl.split('?');
      newUrlArr.push(tmpUrlArr[0]);
      newUrlArr.push('?' + key + timestamp);
      newUrlArr.push('&' + tmpUrlArr[1]);
    } else {
      newUrlArr.push(urlArr[0]);
      newUrlArr.push('?' + key + timestamp);
    }
    newUrlArr.push(hash);

    return newUrlArr.join('');
  }
};

/**
 * 获取URL参数
 *
 * @param {*} name
 * @returns
 */
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
}

// 返回零点时间
function getZeroDate(time) {
  return time ? dayjs(time).format('YYYY-MM-DD') + ' 00:00:00' : dayjs().format('YYYY-MM-DD') + ' 00:00:00';
}

// 解决氧气马甲包自动重定向到对应马甲包地址
function inTransit() {
  if (/(localhost|10\.|0\.0|192\.168)/.test(location.origin)) return;
  const isMatch = navigator.userAgent.match(/(oxygen|zhuazhua|pomelo|hydrogen|yoyo|lemon|caramel)/g);
  if (isMatch === null) return false;
  const product = isMatch[0];
  if (location.href.indexOf(product) === -1) location.replace(location.href.replace(/\/oxygen\//, `/${product}/`));
}

/**
 * 截取字符
 * 说明：汉字、中文标点、emoji、日文、韩文算作 1个字
 * ASCII, 英文、英文标点、数字算作 0.5个字
 * @params { String } 待处理的字符串
 * @params { Number } 需要截取的长度
 * @params { String } 超出字符代替，默认"..."
 * @returns { String } 还回的字符串
 */
const interceptStr = (str, len, outMsg) => {
  // 绝大部分emoji
  let reg =
    /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;

  let strArr = str ? str.split('') : []; // 字符数组
  let strEmojiArr = []; // emoji对象
  let tempArr;

  let countLen = 0; // 需要转为2倍长度处理，避免小数点
  let strIndex = 0; // 字符数组对应的指针
  let emojiIndex = 0; // emoji对象对应的指针
  let newStrArr = []; // 新字符数组

  outMsg = typeof outMsg !== 'undefined' ? outMsg : '...';

  len = len * 2; // 转为2倍长度处理，避免小数点

  if (!str) {
    return str;
  }

  // 获取到对应的emoji位置
  while ((tempArr = reg.exec(str)) !== null) {
    let word = tempArr[0]; // 获取到emoji
    let wordLen = word.length; // emoji长度
    let startIndex = reg.lastIndex - wordLen; // 出现开始位置

    // console.log('序号：', strIndex, startIndex, endIndex, wordLen);
    strEmojiArr.push({
      word, // emoji字符
      startIndex, // emoji出现的开始位置
      wordLen, // emoji长度
    });
  }

  for (var i = 0; i < strArr.length; i++) {
    // 判断指针是否大于字符数组下标
    if (strIndex > i) {
      continue;
    }

    // 判断是否是emoji
    let emojis = strEmojiArr.filter((item) => {
      emojiIndex++;
      return item.startIndex == strIndex;
    });

    if (emojis.length > 0) {
      countLen += 2;
      if (countLen > len) {
        newStrArr.push(outMsg);
        break;
      }
      let emoji = emojis[0];
      strEmojiArr.splice(emojiIndex, 1); // 删掉已显示过的emoji
      strIndex += Number(emoji.wordLen);
      newStrArr.push(emoji.word);
    } else {
      if (/[\x00-\xff]+/g.test(strArr[i])) {
        countLen += 1;
      } else {
        countLen += 2;
      }
      if (countLen > len) {
        newStrArr.push(outMsg);
        break;
      }
      newStrArr.push(strArr[i]);
      strIndex += 1;
    }
  }

  return newStrArr.join('');
};

function isArray(ary) {
  return Object.prototype.toString.call(ary) === '[object Array]';
}

function isEmptyObject(obj) {
  return obj && Object.prototype.toString.call(obj) === '[object Object]' && JSON.stringify(obj) === '{}';
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isString(str) {
  return Object.prototype.toString.call(str) === '[object String]';
}

/**
 * 时间戳是不是今天
 * @param {Number} t 时间戳
 */
function isToday(t) {
  let now = new Date();
  let d = new Date(t);
  return now.getFullYear() === d.getFullYear() && now.getMonth() === d.getMonth() && now.getDate() === d.getDate();
}

/**
 * replace 无效, 浏览器有效
 * 出处：https://stackoverflow.com/questions/14333620/android-webview-location-replace-doesnt-work
 */
const locationReplace = (url) => {
  if (history.replaceState) {
    history.replaceState(null, document.title, url);
    history.go(0);
    location.reload();
  } else {
    location.replace(url);
  }
};

/**
 *  咪呀头像规则
 *  @params { String } icon, 服务端返回的路径
 *  @params { Number } iconType, 图像对应的尺寸0, 1, 2
 */
function miyaParsingPath(icon = '', iconType) {
  if (/https?:\/\//i.test(icon)) {
    return oldWay(icon);
  } else {
    iconType = typeof iconType !== 'undefined' ? iconType : 0;
    return `https://res.miyachat.com/${icon}` + (iconType ? `?x-oss-process=style/icon_${iconType}_jpg` : '');
  }
}

// 旧版本的解析方式
function oldWay(Icon = '', idx = 0, domain) {
  // 解析图片路径,Icon为需要解析的Icon，idx为0和1，代表不同尺寸的图片，一般头像都用0
  typeof idx === 'undefined' && (idx = 0);
  return (domain || CDNDOMAIN) + '/upload/icon/' + Icon.substring(0, 2) + '/' + Icon.substring(0, 4) + '/' + Icon + '_' + idx + '.jpg';
}

// 解析举报上传的图片地址
function parsingFeedback(id, domain) {
  let url = '';

  if (/\/upload\//.test(id)) {
    url = (domain || OSSDOMAIN) + id;
    return url;
  } else if (/upload\//.test(id)) {
    url = (domain || OSSDOMAIN) + '/' + id;
    return url;
  } else {
    url = id.substring(0, 7);
    url += '/' + id.substring(0, 9);
    url += '/' + id + '.jpg';
    return (domain || CDNDOMAIN) + '/upload/feedback/' + url;
  }
}

/**
 * 解析礼物图片路径
 * @param { Number } 礼物id
 * @returns { String }
 */
let parsingGiftPath = (id, isFresh) => {
  let imgUrl = '';

  // 如果是http或https开头
  if (/^(http|https)/.test(id)) {
    imgUrl = id;
  }
  // 如果是 / 开头
  else if (/^\//.test(id)) {
    imgUrl = CDNDOMAIN + id;
  }
  // 只有id
  else {
    id = id || 0;
    imgUrl = CDNDOMAIN + '/resources/gift/' + id + '.png';
  }

  if (isFresh) {
    imgUrl = `${imgUrl}?t=${new Date().getTime()}`;
  }
  return imgUrl;
};

/**
 *  通用头像规则，支持mizhua,xhx
 * @param {string} [Icon=''] 服务端返回的路径
 * @param {*} idx 看着像图像对应的尺寸0, 1, 2
 * @param {*} domain 直接替换域名
 * @param {number} [width=50] 返回图片宽度,默认50,等比缩放
 * @returns
 */
function parsingPath(Icon = '', idx, domain, width = 120) {
  if (/https?:\/\//i.test(Icon)) {
    return Icon;
  }
  // 判断新旧解析的标准
  if (/upload\//g.test(Icon)) {
    // 域名优先
    if (domain) {
      return `${domain}/${Icon}`;
    }
    // 新头像解析规则
    if (envConf.pic) {
      return `${envConf.pic}/${Icon}?x-oss-process=image/resize,m_lfit,h_${width},w_${width}`;
    }
    // 默认
    return `${OSSDOMAIN}/${Icon}`;
  }
  return oldWay(Icon, idx, domain);
}
function yesParsingPath(Icon = '', idx, domain, width = 120) {
  if (/https?:\/\//i.test(Icon)) {
    return Icon;
  }
  // 判断新旧解析的标准
  if (/upload\//g.test(Icon) || /\/resources\//.test(Icon) || /\/wechat_head_img\//.test(Icon)) {
    // 域名优先
    if (domain) {
      return `${domain}/${Icon}`;
    }
    // 新头像解析规则
    if (envConf.pic) {
      return `${envConf.pic}/${Icon}?x-oss-process=image/resize,m_lfit,h_${width},w_${width}`;
    }
    // 默认
    return `${OSSDOMAIN}/${Icon}`;
  }
  return oldWay(Icon, idx, domain);
}

/**
 * 剩余时间
 * @param val
 * @returns {string}
 */
function remainTime(val) {
  let d, h, m, s;
  let res = '';
  d = parseInt(+val / (24 * 3600));
  h = (val - d * 24 * 3600) / 3600;
  m = val - d * 24 * 3600 - parseInt(h) * 3600; // 分钟
  m = m / 60;
  s = val - d * 24 * 3600 - parseInt(h) * 3600 - parseInt(m) * 60;
  // res += d + '天' + parseInt(h) + '时' + parseInt(m) + '分' + s + '秒'
  //  时 的繁体字 "時"
  res += d + '天' + parseInt(h) + '时' + parseInt(m) + '分';
  return res;
  /*return {
    d, h:parseInt(h), m:parseInt(m), s
  }*/
}

/**
 * 睡眠若干毫秒, 与async/await配合使用, 多用于等待动画结束
 * @param {Number} ms 毫秒值
 */
function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

let top = 0;

function stopBodyScroll(isFixed) {
  let bodyEl = document.body;
  if (isFixed) {
    top = window.scrollY;

    bodyEl.style.position = 'fixed';
    bodyEl.style.top = -top + 'px';
  } else {
    bodyEl.style.position = 'static';
    bodyEl.style.top = 'unset';

    window.scrollTo(0, top); // 回到原先的top
  }
}

/**
 * 节流函数就是只允许一个函数在一定时间内执行一次,适用于高频率事件。
 * @param  {Function} fn                [执行函数]
 * @param  {Number}   [interval=1000]       [间隔时间]
 * @return {[type]}                   [function]
 */
function throttle(fn, interval = 2000) {
  let timer;

  let preTime = +new Date();
  return function () {
    const self = this;

    const args = arguments;

    const curTime = +new Date();
    if (timer) clearTimeout(timer);
    // 超过间隔时间执行,并记录当前时间是新的时间点
    if (curTime - preTime >= interval) {
      preTime = curTime;
      fn.apply(self, arguments);
    } else {
      // 间隔时间内设置定时器,保证即使停止操作也至少执行一次
      timer = setTimeout(() => {
        fn.apply(self, args);
      }, interval);
    }
  };
}

// 驼峰转换下划线
function toLine(name) {
  return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}
// 复制字符串到剪贴板
function copyText(txt) {
  if (document.execCommand) {
    let tmpInput = document.getElementById('copy-text-input');

    if (!tmpInput) {
      tmpInput = document.createElement('input');
      tmpInput.id = 'copy-text-input';
      tmpInput.setAttribute('type', 'text');
      tmpInput.setAttribute('readonly', 'true');
      tmpInput.style.cssText = ['position:absolute', 'left: -100%', 'top: -100%'].join(';');
      document.body.appendChild(tmpInput);
    }
    tmpInput.value = txt;

    tmpInput.select();
    document.execCommand('Copy');
    return true;
  } else if (window.clipboardData) {
    window.clipboardData.setData('Text', txt);
    return true;
  } else {
    return false;
  }
}
/**
 * 刷新app里面的webview
 * @params { Object } {url, title, type}
 */
function tryCallApp(data) {
  if (!data) return;

  let scheme = curScheme;

  data.url = data.url ? data.url : location.href;
  data.url = encodeURIComponent(data.url);
  data.title = data.title ? encodeURIComponent(data.title) : '';

  // 和app协定的scheme
  let url = scheme + '?dyaction=web&url=' + data.url + '&title=' + data.title;
  console.log('---------scheme-------', url);
  if (data.isRefresh) {
    url += '&isrefresh=1';
  }

  location.href = url;
}

/**
 * 唤醒路由(支持多路由方式)
 * @param {url, title, type, dyaction, scheme} data
 * 例如
 * { url: `roomid=${roomId}`, dyaction: 'room' }或者{ url: 'tab=', dyaction: 'home' }
 */
function tryWakeApp(data) {
  if (!data) return;

  const scheme = data.scheme || curProject.secheme;
  data.url = data.url ? data.url : location.href;
  const isUrl = validate('URL', data.url);
  if (isUrl) data.url = `url=${encodeURIComponent(data.url)}`;

  data.title = data.title ? encodeURIComponent(data.title) : '';

  // 和app协定的scheme
  let url = `${scheme}?dyaction=${data.dyaction}&${data.url}`;

  if (data.isRefresh) {
    url += '&isrefresh=1';
  }

  location.href = url;
}

/**
 *
 * @param {String, Number, Boolean, Null, Undefined, Symbol, Object} type 判断类型
 * @param {*} data 判断数据
 */
function typeIs(type, data) {
  type = type.charAt(0).toUpperCase() + type.slice(1);
  return Object.prototype.toString.call(data) === `[object ${type}]`;
}

/**
 * 以某属性(一般是名称)排序,适用于子活动|福利|抽奖配置等
 * 属性配置需以 -1 | _1 | 1 等格式结尾
 * @param { arr } 待排序数组
 * @param { attr } 排序属性
 */
function sortByName(arr, attr = 'name') {
  if (arr.length > 1 && /(-|_)?\d+$/.test(arr[0][attr])) {
    let m, index1, index2;
    arr.sort((a, b) => {
      m = a[attr].match(/(-|_)?(\d+)$/);
      index1 = m ? Number(m[2]) : 0;
      m = b[attr].match(/(-|_)?(\d+)$/);
      index2 = m ? Number(m[2]) : 0;
      return index1 - index2;
    });
  }
  return arr;
}
/**
 * 时长转为字符串 120 -> 02:00
 * @param { Number} d 时长s
 */
function duration2str(d) {
  if (d <= 0) return '00:00';
  let h = Math.floor(d / 3600);
  d = d % 3600;
  let m = Math.floor(d / 60);
  let s = d % 60;
  return h ? `${formatNum(h)}:${formatNum(m)}:${formatNum(s)}` : `${formatNum(m)}:${formatNum(s)}`;
}
/**
 * 时长转为字符串 86400 -> 1天
 * @param { Number} time 时长s
 */
function duration2str2(time) {
  let d,
    h,
    m,
    s,
    res = '';
  d = Math.floor(time / 86400);
  time = time % 86400;
  h = Math.floor(time / 3600);
  time = time % 3600;
  m = Math.floor(time / 60);
  s = time % 60;
  if (d !== 0) {
    res += d + '天';
  }
  if (h !== 0) {
    res += h + '小时';
  }
  if (m !== 0) {
    res += m + '分钟';
  }
  if (s !== 0) {
    res += s + '秒';
  }
  return res;
}

//根据接口的rewardUnit(单位) 字段将 expiredTime（多少秒）转换为 实际的（天、时、分、秒）单位
function getExpiredTime(unit, expiredTime) {
  const index = ['天', '小时', '分', '秒'].indexOf(unit);
  return ([expiredTime / 60 / 60 / 24, expiredTime / 60 / 60, expiredTime / 60, expiredTime][index] || expiredTime) + unit;
}

// 处理SDK_REPORT的value参数，默认返回string，除非type传number才返回number类型
function formatReportValue(value, type) {
  if (type === 'number') return isNaN(value) ? 0 : value;
  return !value ? '' : String(value);
}

/**
 * 返回正常年-月-日 时:分:秒格式
 * @returns
 */
function toISOString() {
  const date = dayjs().format('YYYY-MM-DD HH:mm:ss');
  return date;
}

/**
 * arrayBuffer转成base64
 * @param {*} buffer
 * @returns
 */
function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

// 替换url参数,如果存在则替换,不存在则增加
function replaceParamVal(url, paramName, replaceVal) {
  const oUrl = url.toString();
  const hashUrl = oUrl.split('#');
  let pre = hashUrl[0] || '';
  const suffix = hashUrl[1] || '';

  if (pre.indexOf(paramName) > -1) {
    // 存在
    let re = eval('/(' + paramName + '=)([^&]*)/gi');
    pre = pre.replace(re, paramName + '=' + replaceVal);
  } else {
    // 不存在
    let sign = pre.indexOf('?') > -1 ? '&' : '?';
    pre = `${pre}${sign}${paramName}=${replaceVal}`;
  }

  if (suffix) {
    pre = `${pre}#${suffix}`;
  }

  return pre;
}

/**
 * @author Kyle
 * @date date 2021/06/29 10:25:03
 * @Description: 数据转换工具
 */
// =================================================================
function base64ToUint8Array(base64String) {
  if (!base64String) return;
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// 发布订阅
function addSubscribe(data = {}, callback) {
  // 收集订阅ids
  const ids = Object.keys(data).map((item) => +item);

  window.subscribeCallback = function (msg) {
    console.log('subscribeCallback---', msg);
    // ios特殊处理一下格式
    msg = browser.ios ? msg : JSON.parse(msg);

    // pc可能多个页面订阅推送，要过滤
    if (!ids.includes(msg.activityCmdId)) return;

    // 有些不需要解析
    let res = null;
    // ios特殊处理一下格式
    if (data[msg.activityCmdId]) res = decode(data[msg.activityCmdId], browser.ios ? base64ToUint8Array(msg.bin.replace(/[\r\n↵]/g, '')) : new Uint8Array(msg.bin));

    console.info('推送id: ' + msg.activityCmdId, res, msg);
    // 触发回调,返回解析后数据和原始数据
    callback && callback(res, msg);
  };

  // pc没加监听方法,只需要加回调全部推送,我们自己区分,ids用于批量监听，id为了兼容旧版本只能监听一个,pcBrowserId为了给pc做区分窗口
  if (window.jsBridgeClient && window.jsBridgeClient.subscribe) {
    return window.jsBridgeClient.subscribe({ ids, id: ids[0], pcBrowserId: getQueryString('pcBrowserId') || '' });
  } else {
    return Promise.reject('不存在subscribe方法');
  }
}

/**
 *
 * @param {*} $el 滑动dom
 * @param {*} number scrollTop距离
 * @param {*} time 滑动时间
 */
function scrollTop($el, number, time) {
  if (!time) {
    $el.scrollTop = number;
    return;
  }
  const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
  let spacingInex = time / spacingTime; // 计算循环的次数
  let nowTop = $el.scrollTop; // 获取当前滚动条位置
  let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
  let scrollTimer = setInterval(() => {
    if (spacingInex > 0) {
      spacingInex--;
      scrollTop($el, (nowTop += everTop));
    } else {
      clearInterval(scrollTimer); // 清除计时器
    }
  }, spacingTime);
}

export {
  addZero,
  avatarAnalysis,
  browser,
  cleanCache,
  createDateAry,
  createFormSubmit,
  createHref,
  createRandom,
  debounce,
  escapeHtml,
  fixedIOSScroll,
  flexHeight,
  formatDate,
  formatDateObj,
  formatDuring,
  formatNum,
  getAbsoluteURL,
  getClearCacheUrl,
  getQueryString,
  getZeroDate,
  inTransit,
  interceptStr,
  isArray,
  isEmptyObject,
  isObject,
  isString,
  isToday,
  locationReplace,
  miyaParsingPath,
  yesParsingPath,
  oldWay,
  parsingFeedback,
  parsingGiftPath,
  parsingPath,
  remainTime,
  sleep,
  stopBodyScroll,
  throttle,
  toLine,
  tryCallApp,
  tryWakeApp,
  typeIs,
  sortByName,
  duration2str,
  duration2str2,
  copyText,
  getExpiredTime,
  toISOString,
  formatReportValue,
  replaceParamVal,
  arrayBufferToBase64,
  addSubscribe,
  base64ToUint8Array,
  scrollTop,
};
